if (!customElements.get('timeline-accordion')) {
  class TimelineAccordion extends window.BaseComponent {
    constructor() {
      super();
    }

    init() {
      this.items = this.querySelectorAll('.timeline-item');
      this.headings = this.querySelectorAll('.timeline-heading');
      this.dots = this.querySelectorAll('.timeline-dot-wrapper');
      this.isMobile = window.innerWidth < 750;

      this.headings.forEach((heading, index) => {
        heading.addEventListener('click', () => this.toggleItem(index));
      });

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.toggleItem(index));
      });

      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth < 750;
      });
    }

    toggleItem(index) {
      if (this.items[index].classList.contains('is-active')) return;

      const currentItem = this.querySelector('.timeline-item.is-active');
      const targetItem = this.items[index];

      // Mobile: Instant switch
      if (this.isMobile) {
        if (currentItem) currentItem.classList.remove('is-active');
        targetItem.classList.add('is-active');
        return;
      }

      // Desktop: Smooth GSAP Transition
      if (typeof gsap !== 'undefined') {
        const currentContent = currentItem?.querySelector('.timeline-content');
        const targetContent = targetItem.querySelector('.timeline-content');

        const tl = gsap.timeline({
          onStart: () => {
            targetItem.classList.add('is-active');
            if (currentItem) currentItem.classList.remove('is-active');
          }
        });

        if (currentContent) {
          gsap.set(currentContent, { height: currentContent.offsetHeight });
          tl.to(currentContent, {
            height: 0,
            opacity: 0,
            duration: 0.4,
            ease: 'power2.inOut',
            clearProps: 'height,opacity'
          }, 0);
        }

        tl.fromTo(targetContent,
          { height: 0, opacity: 0 },
          {
            height: 'auto',
            opacity: 1,
            duration: 0.4,
            ease: 'power2.inOut',
            clearProps: 'height'
          }, 0);
      } else {
        if (currentItem) currentItem.classList.remove('is-active');
        targetItem.classList.add('is-active');
      }
    }
  }

  if (window.BaseComponent) {
    customElements.define('timeline-accordion', TimelineAccordion);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      if (window.BaseComponent) customElements.define('timeline-accordion', TimelineAccordion);
    });
  }
}
